<template>
  <div class="rest touch" @click="handleClick">
    <img
      v-if="restType === 'image'"
      class="rest__background-media" 
      :src="restMedia"
    >
    <video
      v-if="restType === 'video'"
      class="rest__background-media" 
      :src="restMedia"
      autoplay
      loop
      muted
    ></video>
    <tiny-slider class="rest__slides" v-if="restType === 'slider'" v-bind="sliderConfig">
      <img
        v-for="image in $store.state.config.restMedia"
        class="rest__slide-image" 
        :key="image"
        :src="`${$store.state.assetsPath}${image}`">
    </tiny-slider>
    <div class="rest__prompt-wrapper">
    <img 
      class="rest__touch-prompt" 
      :class="{ 'rest__touch-prompt--visible': showTouchPrompt }"
      src="/assets/touch-prompt.png"
    >
    <div class="rest__touch-label" :class="{ 'rest__touch-label--visible': showTouchPrompt }">Touch Screen to Start<br>المس الشاشة للبدء</div>
    </div>
    <img
      v-if="$store.state.config.restCompanyLogo"
      class="rest__company-logo"
      :src="`${$store.state.assetsPath}${$store.state.config.restCompanyLogo}`"
    >
    <img
      v-if="$store.state.config.restDevelopmentLogo"
      class="rest__development-logo"
      :src="`${$store.state.assetsPath}${$store.state.config.restDevelopmentLogo}`"
    >
  </div>
</template>
<script>
import TinySlider from 'vue-tiny-slider';
import { mapActions } from 'vuex'
export default {
  name: 'rest',

  components: { TinySlider },

  data () {
    return {
      sliderConfig: {
        mode: "gallery",
        autoplay: true,
        autoplayTimeout: 7500,
        autoplayButton: false,
        autoplayButtonOutput: false,
        mouseDrag: false,
        controls: false,
        loop: true,
        items: 1,
        gutter: 0,
        nav: false,
        speed: 1200,
        animateIn: 'background--show',
        animateOut: 'background--hide',        
      },
    }
  },

  computed: {
    restType () {
      return this.$store.state.config.restType
    },

    showTouchPrompt () {
      return !this.$store.state.isBottomBarVisible
    },
    
    languages () {
      return this.$store.getters.languages
    }
  },

  methods: {
    ...mapActions([
      'toggleBottomBarVisibility',
    ]),

    handleClick () {
      if (this.languages.length > 1) {
        this.$router.push('/language').catch(() => {
          // navigating to this route "fails" if we skip it with the route guard in router.js (and we skip it if there is only 1 category, no need to show category selection in this case)
          // the "failed" navigation causes a console error, this catch supresses that error (because in our case, it's not an error 👍🏻)
          // see https://github.com/vuejs/vue-router/issues/2881#issuecomment-520554378
        })
      } else {
        this.$router.push('/select').catch(() => {
          // navigating to this route "fails" if we skip it with the route guard in router.js (and we skip it if there is only 1 category, no need to show category selection in this case)
          // the "failed" navigation causes a console error, this catch supresses that error (because in our case, it's not an error 👍🏻)
          // see https://github.com/vuejs/vue-router/issues/2881#issuecomment-520554378
        })
      }
      
    }
  }
}
</script>
<style lang="scss">
.rest {
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;

  &__slides {
    .rest__slide-image {
      height: 108rem;
      width: 192rem;
      object-fit: cover;
    }
  }

  &__background-media {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }

  &__company-logo {
    position: absolute;
    opacity: 0.75;
    right: 0;
    top: 0;
    width: 20rem;
  }

  &__development-logo {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 50rem;    
  }

  &__prompt-wrapper {
    bottom: 15%;
    left: 50%;
    transform: translateX(-50%);
    position: absolute; 
    text-align: center;
  }
  
  &__touch-prompt {
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    width: 7rem;
    margin-bottom: 2rem;

    &--visible {
      animation: pulse 4s ease-in-out 0.6s infinite;
      transition: opacity 0.3s ease-in-out 0.3s;
      opacity: 0.7;
    }
  }

  &__touch-label {
    font-size: 4rem;
    opacity: 0;
    text-transform: uppercase;
    letter-spacing: 0.05em;

    &--visible {
      animation: pulse 4s ease-in-out 0.6s infinite;
      transition: opacity 0.3s ease-in-out 0.3s;
      opacity: 0.7;
    }    
  }  


  @keyframes pulse {
    0% {  transform: scale(1); opacity: 0.7; }
    5% { transform: scale(1.1); opacity: 1; }
    10% { transform: scale(1);}
    15% { transform: scale(1.1); opacity: 1; }
    20% { transform: scale(1); opacity: 0.7; }
    100% { transform: scale(1); opacity: 0.7; }
  }  
}
</style>
